import { twMerge } from '@/lib/classname/twMerge'

export function LoyaltyGradient({ gradient }: { gradient?: string }) {
  if (!gradient) return

  return (
    <div
      className="absolute inset-0"
      style={{
        background: `linear-gradient(${gradient === 'horizontal' ? '264deg' : '-358deg'}, #793ab0 0, #793ab050 0.64%, #793AB0 80.78%)`,
      }}
    />
  )
}

export function LoyaltyBackgroundImage({
  imageSrc,
  alt,
  className,
}: {
  imageSrc?: string
  alt?: string
  className?: string
}) {
  if (!imageSrc) return

  return (
    <div className="absolute inset-0">
      <img src={imageSrc} alt={alt} className={twMerge(className, 'absolute bottom-0')} />
    </div>
  )
}
